'use client';

import { useRenownAuth } from '@powerhousedao/reactor-browser';
import { AuthGuardLoadingFallback } from './auth-guard-loading-fallback';
import { AuthGuardLoginFallback } from './auth-guard-login-fallback';
import type { ReactNode } from 'react';
const DEFAULT_LOADING_FALLBACK = <AuthGuardLoadingFallback />;
const DEFAULT_LOGIN_FALLBACK = <AuthGuardLoginFallback />;
interface AuthGuardProps {
  /** Content rendered only once the user is authenticated. */
  children: ReactNode;
  /** Shown while auth state is still resolving. Defaults to a centered spinner. */
  loadingFallback?: ReactNode;
  /** Shown when the user is settled-unauthenticated. Defaults to a sign-in card. */
  loginFallback?: ReactNode;
}
function AuthGuard(t0) {
  const {
    children,
    loadingFallback: t1,
    loginFallback: t2
  } = t0;
  const loadingFallback = t1 === undefined ? DEFAULT_LOADING_FALLBACK : t1;
  const loginFallback = t2 === undefined ? DEFAULT_LOGIN_FALLBACK : t2;
  const {
    status,
    address
  } = useRenownAuth();
  const isResolving = status === undefined || status === "loading" || status === "checking";
  const isAuthenticated = status === "authorized" && Boolean(address);
  if (isResolving) {
    return loadingFallback;
  }
  if (!isAuthenticated) {
    return loginFallback;
  }
  return children;
}
export { AuthGuard };
export type { AuthGuardProps };